import { Form, FormDownloadDocumentLink, FormDropDown, FormInput, FormSwitch } from 'metrix-common3';
// biome-ignore lint: react is a required import
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialCoverages = ({
    pageCode,
    doUpsertPolicy,
    doGetPolicy,
    allowEdit,
    policy,
    doReducePolicyElement,
    reference,
    validationInfo,
    tooltipInfo,
    doUpsertTooltipInfo,
    doReduceTooltipInfoElement,
}) => {
    const isContractorOptionalCoverageDisplayed = policy.snCommercialBusinessInfo?.contractorOptionalCoverageDisplayed;

    return (
        <>
            <Form
                pageCode={pageCode}
                sectionCode='contentCoverage'
                header={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.contentCoverage' />}
                tooltipInfo={tooltipInfo}
                validationInfo={validationInfo}
                saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                reduceTooltipInfoElement={doReduceTooltipInfoElement}
                saveEvent={doUpsertPolicy}
                cancelEvent={doGetPolicy}
                allowEdit={allowEdit}
            >
                <FormInput
                    type='currency'
                    fieldCode='snCommercialCoverages.coverageContentLimit'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.contentLimit' />}
                    value={policy.snCommercialCoverages?.coverageContentLimit}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialCoverages.coverageContentLimit',
                            value,
                        })
                    }
                    allowEdit
                />
                <FormDropDown
                    fieldCode='snCommercialCoverages.coverageContentDeductibleCode'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.contentDeductible' />}
                    value={{ code: policy.snCommercialCoverages?.coverageContentDeductibleCode }}
                    references={reference?.references['sn-commercial']?.CoverageContentDeductible}
                    referencesEvent={() => reference.doGetReferences('sn-commercial.CoverageContentDeductible')}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialCoverages.coverageContentDeductibleCode',
                            value: value.code,
                        })
                    }
                    allowEdit
                />
            </Form>
            {isContractorOptionalCoverageDisplayed && (
                <Form
                    pageCode={pageCode}
                    sectionCode='contractorOptionalCoverage'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.contractorOptionalCoverage' />}
                    label={
                        <FormattedMessage id='Profile_SupernovaCommercial_Coverages.contractorOptionalCoverageLabel' />
                    }
                    tooltipInfo={tooltipInfo}
                    validationInfo={validationInfo}
                    saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                    reduceTooltipInfoElement={doReduceTooltipInfoElement}
                    saveEvent={doUpsertPolicy}
                    cancelEvent={doGetPolicy}
                    allowEdit={allowEdit}
                >
                    <FormInput
                        type='currency'
                        fieldCode='snCommercialCoverages.contractorEquipmentAmount'
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_Coverages.contractorEquipmentAmount' />
                        }
                        value={policy.snCommercialCoverages?.contractorEquipmentAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.contractorEquipmentAmount',
                                value,
                            })
                        }
                        allowEdit
                        hideDecimals
                    />
                    <FormDownloadDocumentLink
                        target={'contractor-equipment-schedule'}
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_Coverages.contractorOptionalCoverageLink' />
                        }
                        text={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.downloadDocumentLabel' />}
                    />
                    <FormSwitch
                        fieldCode='snCommercialCoverages.acknowledgedEquipmentScheduleUploaded'
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_Coverages.acknowledgedEquipmentScheduleUploaded' />
                        }
                        value={policy.snCommercialCoverages?.acknowledgedEquipmentScheduleUploaded}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.acknowledgedEquipmentScheduleUploaded',
                                value,
                            })
                        }
                        allowEdit
                    />
                    <FormInput
                        type='currency'
                        fieldCode='snCommercialCoverages.toolsAndPropertyAmount'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.toolsAndPropertyAmount' />}
                        value={policy.snCommercialCoverages?.toolsAndPropertyAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.toolsAndPropertyAmount',
                                value,
                            })
                        }
                        allowEdit
                        hideDecimals
                    />
                    <FormInput
                        type='currency'
                        fieldCode='snCommercialCoverages.installationProjectsAmount'
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_Coverages.installationProjectsAmount' />
                        }
                        value={policy.snCommercialCoverages?.installationProjectsAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.installationProjectsAmount',
                                value,
                            })
                        }
                        allowEdit
                        hideDecimals
                    />
                    <FormInput
                        type='number'
                        fieldCode='snCommercialCoverages.annualProjectCount'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.annualProjectCount' />}
                        value={policy.snCommercialCoverages?.annualProjectCount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.annualProjectCount',
                                value,
                            })
                        }
                        allowEdit
                        integer
                    />
                    <FormInput
                        type='currency'
                        fieldCode='snCommercialCoverages.annualInstallationRevenue'
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_Coverages.annualInstallationRevenue' />
                        }
                        value={policy.snCommercialCoverages?.annualInstallationRevenue}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialCoverages.annualInstallationRevenue',
                                value,
                            })
                        }
                        allowEdit
                        hideDecimals
                    />
                </Form>
            )}
            <Form
                pageCode={pageCode}
                sectionCode='liabilityCoverage'
                header={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.liabilityCoverage' />}
                tooltipInfo={tooltipInfo}
                validationInfo={validationInfo}
                saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                reduceTooltipInfoElement={doReduceTooltipInfoElement}
                saveEvent={doUpsertPolicy}
                cancelEvent={doGetPolicy}
                allowEdit={allowEdit}
            >
                <FormDropDown
                    fieldCode='snCommercialCoverages.coverageLiabilityLimitCode'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.liabilityLimitAndDeductible' />}
                    value={{ code: policy.snCommercialCoverages?.coverageLiabilityLimitCode }}
                    references={reference?.references['sn-commercial']?.LiabilityLimit}
                    referencesEvent={() => reference.doGetReferences('sn-commercial.LiabilityLimit')}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialCoverages.coverageLiabilityLimitCode',
                            value: value.code,
                        })
                    }
                    allowEdit
                />
                <FormDropDown
                    fieldCode='snCommercialCoverages.coverageDeductibleForLiabilityCode'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_Coverages.liabilityDeductible' />}
                    value={{ code: policy.snCommercialCoverages?.coverageDeductibleForLiabilityCode }}
                    references={reference?.references['sn-commercial']?.DeductibleForLiability}
                    referencesEvent={() => reference.doGetReferences('sn-commercial.DeductibleForLiability')}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialCoverages.coverageDeductibleForLiabilityCode',
                            value: value.code,
                        })
                    }
                    allowEdit
                />
            </Form>
        </>
    );
};

export default ProfileSupernovaCommercialCoverages;
